import { SectionConfig } from "@services/tracpage/types/trac-page-section-config";
import { SectionIdentifier } from "@services/tracpage/types/trac-page-section-id";

export const DEFAULT_SECTIONS_CONFIG: SectionConfig = {
  [SectionIdentifier.MUSIC]: { id: SectionIdentifier.MUSIC, order: 1 },
  [SectionIdentifier.MERCH]: { id: SectionIdentifier.MERCH, order: 2 },
  [SectionIdentifier.EVENTS]: { id: SectionIdentifier.EVENTS, order: 3 },
};
